import React from 'react'
import injectJss from 'react-jss'
import Swipe from '-!raw-loader!public/assets/svg/fullscreen-swipe.svg'
import compose from 'recompose/compose'
import pure from 'recompose/pure'

const stylSheet = {
    '@keyframes fullscreenSwipe': {
        '0%': {
            transform: 'translateY(0px)',
        },
        '75%': {
            transform: 'translateY(-200px)',
        },
    },

    fullScreenContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 1)',
    },

    swipeContainer: {
        width: 125,
        height: 125,
        animationName: 'fullscreenSwipe',
        animationIterationCount: 'infinite',
        animationDuration: '2s',
        animationDelay: '1s',
    },
}

const style = injectJss(stylSheet)

const FullScreenSwipe = ({ classes }) => (
    <div className={classes.fullScreenContainer}>
        <div className={classes.swipeContainer} dangerouslySetInnerHTML={{ __html: Swipe }} />
    </div>
)

export default compose(
    style,
    pure
)(FullScreenSwipe)
